export { Image, webpPngFallback } from './Image';
